export const areCookiesAccepted = () => {
	if (typeof window === "undefined") {
		return false;
	}
	return localStorage.getItem("cookiesaccepted") === "true";
};

export const acceptCookies = () => {
	if (typeof window === "undefined") {
		return;
	}
	localStorage.setItem("cookiesaccepted", "true");
};
